import { render, staticRenderFns } from "./contactGeneral.vue?vue&type=template&id=1c014082&"
import script from "./contactGeneral.vue?vue&type=script&lang=js&"
export * from "./contactGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports